import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import APIKit from '../../config/APIKit';

export const fetchProfile = createAsyncThunk(
  'profile/fetchProfile',
  async (_, { rejectWithValue }) => {
    try {
      const response = await APIKit.get(`store/details`);
      return response.data;
    } catch (error) {
      // Check if it's a network error
      if (error?.isNetworkError || error?.code === 'NETWORK_ERROR') {
        return rejectWithValue({ 
          type: 'NETWORK_ERROR', 
          message: 'Unable to load store details. Please check your internet connection.' 
        });
      }
      
      if (error && typeof error === 'object' && error.response) {
        return rejectWithValue(error.response?.data || 'Profile get failed');
      }
      return rejectWithValue('Profile get failed');
    }
  }
);

const profileSlice = createSlice({
  name: 'profile',
  initialState: {
    profile: null,
    status: 'idle',
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchProfile.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(fetchProfile.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.profile = action.payload.data || action.payload;
        state.error = null;
      })
      .addCase(fetchProfile.rejected, (state, action) => {
        state.status = 'failed';
        state.error = typeof action.payload === 'string' ? action.payload : 'Banner get failed';
      });
  },
});

export default profileSlice.reducer;
